export default __webpack_public_path__ + "img/eQDZaGxK.20a7d516.svg";